import { render, staticRenderFns } from "./Covid.vue?vue&type=template&id=101b1e69"
import script from "./Covid.vue?vue&type=script&lang=js"
export * from "./Covid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports